import { ColumnEditorOptions } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";
import { ChangeEvent } from "react";

export const InputTextareaEditor = (options: ColumnEditorOptions) => {
    const onChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        if (options.editorCallback) {
            options.editorCallback(event.target.value);
        }
    };
    
    return <InputTextarea className="w-full" autoResize autoFocus value={options.value} onChange={onChange}/>;
}
